export enum IdVerseStatusType {
  Success = 'success',
  FailedRetry = 'failed-retry',
  FailedExpired = 'failed-expired',
  SwitchToKba = 'switch-to-kba'
}

export enum IdVerseStatusIconType {
  Success = 'success',
  Warning = 'warning',
}
